import React from 'react'
import styled from 'react-emotion'
import { StyledFormElement as FormElement } from '../common/FormElement'
import { color, rowHeight } from '../../style'

export const ShareRow = styled(({ className, ...props }) => (
  <FormElement large className={className} {...props} />
))({
  label: 'ShareRow',
  border: 'none',
  marginTop: 5,
  padding: 0,
  '& > *:first-child': {
    marginRight: 15
  }
})

ShareRow.Circle = styled('span')({
  label: 'ShareRowCircle',
  width: rowHeight.default,
  height: rowHeight.default,
  borderRadius: rowHeight.default / 2,
  background: color.greyBlock,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

export default ShareRow
